import React from 'react';
import styled from 'styled-components';
import { toRem } from 'design';
import { H1 } from '../Typography';

interface ILogoProps {
  className?: string;
  isTextLogo?: boolean;
}

const SVG = styled.svg`
  width: ${toRem(34)};
  height: ${toRem(36)};
`;

const StyledH1 = styled(H1)`
  /* off-scale exception: brand wordmark, intentionally outside the type scale — do not tokenize (see DESIGN_ALIGNMENT_PLAN decision log) */
  font-size: ${toRem(48)};
  /* off-scale exception: brand wordmark, paired with its off-scale 48px size */
  line-height: ${toRem(42)};
  color: white;
`;

const Logo: React.FC<ILogoProps> = ({ className, isTextLogo }) => {
  if (isTextLogo) return <StyledH1>kickfin</StyledH1>;

  return (
    <SVG className={className} viewBox="0 0 34 33" aria-label="Kickfin Logo">
      <g clipPath="url(#clip0_2065_20121)">
        <path d="M0.572998 32.7057H33.2787L0.572998 0V32.7057Z" fill="#00B4CC" />
        <path d="M0.572998 13.7364V0H14.3094L0.572998 13.7364Z" fill="#00E0FF" />
        <path d="M22.8007 0L0.572998 22.2279V32.7057L33.2787 0H22.8007Z" fill="#00E0FF" />
      </g>
      <defs>
        <clipPath id="clip0_2065_20121">
          <rect width="32.7057" height="32.7057" fill="white" transform="translate(0.572998)" />
        </clipPath>
      </defs>
    </SVG>
  );
};

export default Logo;
